import axios, { ApiResponse, getRequestError } from "../../utils/axios";
import {
  GetCreditErrors,
  GetPanelsErrors,
  GetTokenErrors,
  RegisterPanelErrors,
  RequestOTPErrors, RequestRegisterOTPErrors,
  SetAuthDataErrors,
} from "./auth.error";
import { AccountType, ApiPanelRecord } from "./auth.entity";
import { makeCall, Methods } from "../../utils/makeCall";

export type RequestOTPRequest = { phone: string };
export type RequestOTPResponse = { TransactionHash: string };

export const requestOTP = (
  request: RequestOTPRequest
): ApiResponse<RequestOTPResponse, RequestOTPErrors> => {
  return axios
    .get<RequestOTPResponse>("/RequestOTP", {
      headers: {
        phone: request.phone,
      },
    })
    .then((res) => ({
      response: res.data,
    }))
    .catch((error) => {
      return { error: getRequestError<RequestOTPErrors>(error) };
    });
};
export type RequestRegisterOTPRequest = { phone: string };
export type RequestRegisterOTPResponse = RequestOTPResponse;

export const requestRegisterOTP = (
  request: RequestRegisterOTPRequest
): ApiResponse<RequestRegisterOTPResponse, RequestRegisterOTPErrors> => {
  return axios
    .get<RequestRegisterOTPResponse>("/RequestRegisterOTP", {
      headers: {
        phone: request.phone,
      },
    })
    .then((res) => ({
      response: res.data,
    }))
    .catch((error) => {
      return { error: getRequestError<RequestRegisterOTPErrors>(error) };
    });
};

export type GetTokenRequest = {
  phone: string;
  otpKey: string;
  transactionHash: string;
};
export type GetTokenResponse = { token: string; has_panel: boolean };

export const getToken = (
  request: GetTokenRequest
): ApiResponse<GetTokenResponse, GetTokenErrors> => {
  return axios
    .get<GetTokenResponse>("/GetToken", {
      headers: {
        phone: request.phone,
        otpKey: request.otpKey,
        transactionHash: request.transactionHash
      },
    })
    .then((res) => ({
      response: res.data,
    }))
    .catch((error) => {
      return { error: getRequestError<GetTokenErrors>(error) };
    });
};

export type RegisterPanelRequest = {
  name: string;
  owner_name: string;
  type: AccountType;
};
export type RegisterPanelResponse = undefined;

export const registerPanel = makeCall<
  RegisterPanelRequest,
  RegisterPanelResponse,
  RegisterPanelErrors
>(Methods.RegisterPanel);

export type GetPanelsRequest = void;
export type GetPanelsResponse = ApiPanelRecord | undefined;

export const getPanels = makeCall<
  GetPanelsRequest,
  GetPanelsResponse,
  GetPanelsErrors
>(Methods.GetPanels);

export type SetAuthDataRequest = Partial<
  Pick<
    ApiPanelRecord,
    | "full_name"
    | "shenase_melli"
    | "economic_number"
    | "phone"
    | "land_line_phone"
    | "address"
    | "zip_code"
    | "establishment_file_id"
    | "changes_file_id"
    | "permission_file_id"
    | "national_code"
  >
>;
export type SetAuthDataResponse = void;

export const setAuthData = makeCall<
  SetAuthDataRequest,
  SetAuthDataResponse,
  SetAuthDataErrors
>(Methods.SetAuthData);

export type GetCreditRequest = void;
export type GetCreditResponse = { Credit: number; ExpireDate: string };

export const getCredit = makeCall<
  GetCreditRequest,
  GetCreditResponse,
  GetCreditErrors
>(Methods.GetCredit);
